import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '@jetbrains/ring-ui/components/button/button';
import Icon from '@jetbrains/ring-ui/components/icon';
import cancelIcon from '@jetbrains/icons/close';
import { assignTestId } from '@app/common/infra/tests/assign-test-id';
import styles from './assign-user-dialog.css';
export function AssignButton({ assigned, onAssign, onUnAssign, canUnassign = true }) {
    return (_jsxs("span", { children: [_jsx(Button, { disabled: assigned, text: true, onClick: onAssign, className: styles.listButton, ...assignTestId('assign-button'), children: assigned ? 'Assigned' : 'Assign' }), assigned && canUnassign && (_jsx(Icon, { title: "Unassign", glyph: cancelIcon, onClick: onUnAssign, className: styles.listButtonIcon, size: Icon.Size.Size12, ...assignTestId('unassign-button') }))] }));
}
